const DEVICE_TOKEN_KEY = 'idem_device_token';

export function getIdemDeviceToken() {
  try {
    return localStorage.getItem(DEVICE_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setIdemDeviceToken(token) {
  try {
    if (!token) {
      localStorage.removeItem(DEVICE_TOKEN_KEY);
      return;
    }
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
  } catch {
    // Storage is best-effort in the lab app.
  }
}

export function clearIdemDeviceToken() {
  setIdemDeviceToken('');
}
